export default class SpecialistInfoController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/specialistInfo/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/delete', 'post', params, axiosOption, httpOption);
  }

  static startOnlyFlowSpecialistInfo (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/startOnly/flowSpecialistInfo', 'post', params, axiosOption, httpOption);
  }

  static startWithBusinessKeyFlowSpecialistInfo (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/startWithBusinessKey/flowSpecialistInfo', 'post', params, axiosOption, httpOption);
  }

  static startAndTakeUserTaskFlowSpecialistInfo (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/startAndTakeUserTask/flowSpecialistInfo', 'post', params, axiosOption, httpOption);
  }

  static startAndSaveDraftFlowSpecialistInfo (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/startAndSaveDraft/flowSpecialistInfo', 'post', params, axiosOption, httpOption);
  }

  static submitUserTaskFlowSpecialistInfo (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/submitUserTask/flowSpecialistInfo', 'post', params, axiosOption, httpOption);
  }

  static viewTaskBusinessDataFlowSpecialistInfo (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/viewTaskBusinessData/flowSpecialistInfo', 'get', params, axiosOption, httpOption);
  }

  static viewHistoricTaskBusinessDataFlowSpecialistInfo (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/viewHistoricTaskBusinessData/flowSpecialistInfo', 'get', params, axiosOption, httpOption);
  }

  static listWorkOrderFlowSpecialistInfo (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/listWorkOrder/flowSpecialistInfo', 'post', params, axiosOption, httpOption);
  }
  static checkApply (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/specialistInfo/checkApply', 'get', params, axiosOption, httpOption);
  }
}
